/**
 * Environment mode helper
 * Separated into its own file to make testing easier
 */
export { MODE, type Mode } from "./mode";

export function getMode(): string {
  return import.meta.env.MODE;
}
